module.exports = __webpack_public_path__ + "static/img/rightbonnom.6de72fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/rightbonnom.png
// module id = 7/7W
// module chunks = 1